import React, { createContext, useContext, useState, useEffect } from 'react';
import LoginModal from '../components/LoginModal';

const GlobalStateContext = createContext();

// Garante objeto vazio se o provider não estiver acima na árvore, evitando crashes ao destruturar
export const useGlobalState = () => useContext(GlobalStateContext) || {};

export const GlobalStateProvider = ({ children }) => {
  const [showLogin, setShowLogin] = useState(false);
  const [activeLoginTab, setActiveLoginTab] = useState('login');
  const [user, setUserState] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user_data')) || null;
    } catch {
      return null;
    }
  });

  const setUser = (value) => {
    setUserState(value);
    try {
      if (value) {
        localStorage.setItem('user_data', JSON.stringify(value));
      } else {
        localStorage.removeItem('user_data');
      }
    } catch (_) {}
  };

  // Mantém o contexto alinhado a alterações externas (ex.: outra aba ou login social)
  useEffect(() => {
    const syncUser = () => {
      try {
        const stored = localStorage.getItem('user_data');
        const parsed = stored ? JSON.parse(stored) : null;
        setUserState(parsed);
      } catch (_) {}
    };
    syncUser();
    window.addEventListener('storage', syncUser);
    return () => window.removeEventListener('storage', syncUser);
  }, []);

  const handleOpenLogin = () => {
    setActiveLoginTab('login');
    setShowLogin(true);
  };

  const handleOpenRegister = () => {
    setActiveLoginTab('register');
    setShowLogin(true);
  };

  const handleCloseLogin = () => {
    setShowLogin(false);
  };

  const value = {
    showLogin,
    activeLoginTab,
    handleOpenLogin,
    handleOpenRegister,
    handleCloseLogin,
    user,
    setUser,
  };

  return (
    <GlobalStateContext.Provider value={value}>
      {children}
      {showLogin && (
        <LoginModal
          onClose={handleCloseLogin}
          activeTab={activeLoginTab} // Pass the active tab to the modal
          setActiveTab={setActiveLoginTab}
          setUser={setUser}
        />
      )}
    </GlobalStateContext.Provider>
  );
};

export default GlobalStateContext;